const resumeURL = 'https://resume.raullarosa.com'
const emailURL = 'mailto:raullarosa.personal@gmail.com'
const linkedinURL = 'https://linkedin.com/in/raullarosa'
const bthvURL = 'https://travel.gov.bs/'
const rapidURL = 'https://www.instagram.com/bahamasfeedingnetwork/'
const bahamastogetherURL = 'https://www.instagram.com/bahamastogether/'
const bodhiURL = 'https://bodhi.software/'
const thinksimpleURL = 'https://thinksimple.com/'
const ultimateURL = 'https://www.ukg.com/'
const boeingURL = 'https://www.boeing.com/'
const scorbotURL = 'https://www.scorbot.com/'

export default {
  resumeURL,
  emailURL,
  linkedinURL,
  bthvURL,
  bahamastogetherURL,
  rapidURL,
  bodhiURL,
  thinksimpleURL,
  ultimateURL,
  boeingURL,
  scorbotURL
}